var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 'wells')?_c('AdWells',{attrs:{"url":_vm.url,"img":_vm.img}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }